import {
  parseApplicationProducts
} from 'products/productsParser';
import {
  setApplicationProducts,
  setFertilityChemicalTypes,
  setFertilizerSubstanceTypes
} from 'products';

export const processFertilizerSubstanceTypes = ({dispatch, fertilizerSubstanceTypes}) => {
  dispatch(setFertilizerSubstanceTypes(fertilizerSubstanceTypes));
  return Promise.resolve( fertilizerSubstanceTypes );
};

export const processFertilityChemicalTypes = ({dispatch, fertilityChemicalTypes}) => {
  dispatch(setFertilityChemicalTypes(fertilityChemicalTypes));
  return Promise.resolve( fertilityChemicalTypes );
};

export const processApplicationProducts = ({ applicationType, dispatch, rawProducts, substanceTypeUuid }) => {
  const products = parseApplicationProducts({ applicationType, rawProducts });
  dispatch(setApplicationProducts({ applicationType, products, substanceTypeUuid }));
  return Promise.resolve( products );
};
